export default "__VITE_ASSET__b0RP4Ndf__"